import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaBuysellads,
  FaQuestionCircle,
  FaCriticalRole,
  FaSearch,
  FaBug,
  FaBell,
  FaPhoneSquareAlt,
  FaTicketAlt,
  FaRegLightbulb,
} from "react-icons/fa";
import {
  MdOutlinePermScanWifi,
  MdDashboardCustomize,
  MdReport,
  MdReportGmailerrorred,
} from "react-icons/md";
import Logo from "../assets/images/logo.png";
import { HiMiniUsers } from "react-icons/hi2";
import { GrUserWorker } from "react-icons/gr";
import { GoLaw } from "react-icons/go";
import { BiSolidDonateBlood } from "react-icons/bi";
import {
  HiOutlineChevronDown,
  HiOutlineChevronUp,
  HiOutlineMenuAlt3,
} from "react-icons/hi";
import { FaGamepad } from "react-icons/fa6";
import { LiaCitySolid } from "react-icons/lia";
import { BsGlobeAsiaAustralia } from "react-icons/bs";
import { GiModernCity, GiVerticalBanner } from "react-icons/gi";
import { LuBadgeCheck } from "react-icons/lu";
import { GrAchievement } from "react-icons/gr";

import {
  FaHome,
  FaInfoCircle,
  FaFileContract,
  FaUserShield,
} from "react-icons/fa";
import { useAppContext } from "../services/context";
import { getUserData } from "../services/dataManager";
import { IoMdPricetags } from "react-icons/io";

const Sidebar = ({ onToggle }) => {
  const { state, setState } = useAppContext();
  const { permissions, user } = state;
  const [granted, setGranted] = useState([]);
  const [insightGranted, setInsightGranted] = useState(false);
  const location = useLocation();

  const extractPermissions = () => {
    const temp = permissions
      .filter((f) => f.type === "view")
      .map((m) => m.module);
    setGranted(temp);
    const isInsights = permissions.some((f) => f.type === "view-insights");
    setInsightGranted(isInsights);
  };

  useEffect(() => {
    extractPermissions();
    const getUserDataFromLoacal = async () => {
      const response = await getUserData();
      setState((prev) => ({ ...prev, user: response }));
    };
    getUserDataFromLoacal();
  }, [setState]);

  const menuItems = [
    {
      icon: <FaHome />,
      label: "Dashboard",
      path: "/dashboard",
      isPermitted: true,
    },
    {
      icon: <HiMiniUsers />,
      label: "Users",
      path: "/users",
      title: "Users",
      isPermitted: granted.includes("Users"),
    },
    {
      icon: <GrUserWorker />,
      label: "Employees",
      path: "/employees",
      title: "Employees",
      isPermitted: granted.includes("Employees"),
    },
    {
      icon: <BiSolidDonateBlood />,
      label: "Charitable Organization",
      path: "/CharitableOrganization",
      title: "Charitable Organization",
      isPermitted: granted.includes("Charitable_Organizations"),
    },
    // {
    //   icon: <MdReport />,
    //   label: "Reports",
    //   path: "/reports",
    //   title: "Reports Cards",
    //   isPermitted: granted.includes("Reports"),
    // },
  ];

  const systemSettings = [
    {
      icon: <BsGlobeAsiaAustralia />,
      label: "Country",
      path: "/country",
      title: "Countries",
      isPermitted: granted.includes("Countries"),
    },
    {
      icon: <GiModernCity />,
      label: "Province",
      path: "/province",
      title: "Provinces",
      isPermitted: granted.includes("Provinces"),
    },
    {
      icon: <LiaCitySolid />,
      label: "City",
      path: "/city",
      title: "Cities",
      isPermitted: granted.includes("Cities"),
    },
    {
      icon: <FaBuysellads />,
      label: "Ads API",
      path: "/AdsApi",
      title: "Ads API",
      isPermitted: granted.includes("Ads_APIs"),
    },
    {
      icon: <IoMdPricetags />,
      label: "Tags ",
      path: "/tags",
      title: "Tags ",
      isPermitted: granted.includes("Tags"),
    },
    {
      icon: <IoMdPricetags />,
      label: "Game Category ",
      path: "/gamecategory",
      title: "Game Category ",
      isPermitted: granted.includes("Game_Category"),
    },
    {
      icon: <IoMdPricetags />,
      label: "Game Sub Category ",
      path: "/GameSubcategory",
      title: "Game Sub Category ",
      isPermitted: granted.includes("Game_Sub_Category"),
    },
    {
      icon: <FaGamepad />,
      label: "Game Providers ",
      path: "/providers",
      title: "Game Providers ",
      isPermitted: granted.includes("Game_Providers"),
    },
    {
      icon: <FaGamepad />,
      label: "Games",
      path: "/GamingPlatformManagement",
      title: "Games",
      isPermitted: granted.includes("Games"),
    },
    {
      icon: <FaGamepad />,
      label: "Games Reviews",
      path: "/game-reviews",
      title: "Games Reviews",
      isPermitted: granted.includes("Game_Reviews"),
    },
    {
      icon: <LuBadgeCheck />,
      label: "Badges ",
      path: "/badges",
      title: "Badges ",
      isPermitted: granted.includes("Badges"),
    },
    {
      icon: <GrAchievement />,
      label: "Achievements ",
      path: "/achievements",
      title: "Achievements ",
      isPermitted: granted.includes("Achievements"),
    },
    {
      icon: <FaBell />,
      label: "Notifications ",
      path: "/manage-notifications",
      title: "Manage Notifications",
      isPermitted: granted.includes("Notifications"),
    },
  ];

  const pagesManagement = [
    {
      icon: <FaQuestionCircle />,
      label: "FAQs",
      path: "/FaqsManagement",
      title: "FAQs",
      isPermitted: granted.includes("FAQs"),
    },
    {
      icon: <FaFileContract />,
      label: "Manage Blogs",
      path: "/BlogsManagement",
      title: "Manage Blogs",
      isPermitted: granted.includes("Manage_Blogs"),
    },
    {
      icon: <FaRegLightbulb />,
      label: "Knowledge Base",
      path: "/KbManagement",
      title: "Knowledge Base",
      // isPermitted: true,
      isPermitted: granted.includes("Manage_Knowledgebase"),
    },
    {
      icon: <FaTicketAlt />,
      label: "Trouble Tickets ",
      path: "/trouble-tickets",
      title: "Trouble Tickets",
      isPermitted: granted.includes("Feedbacks"),
    },
    {
      icon: <FaPhoneSquareAlt />,
      label: "Contact Us",
      path: "/contactUs",
      title: "Contact Us Messages",
      isPermitted: true,
      isPermitted: granted.includes("Contact_Us"),
    },
    {
      icon: <FaBug />,
      label: "Bug Reports ",
      path: "/bugs",
      title: "Bug Reports ",
      isPermitted: granted.includes("Bug_Reports"),
    },
    {
      icon: <FaHome />,
      label: "Manage Home Page",
      path: "/homePage",
      title: "Manage Home Page",
      isPermitted: granted.includes("Manage_Custom_Pages"),
    },
    {
      icon: <GiVerticalBanner />,
      label: "Banner ",
      path: "/home-banner",
      title: "Banner ",
      isPermitted: granted.includes("Home_Banners"),
    },
    {
      icon: <FaInfoCircle />,
      label: "Manage About Page",
      path: "/aboutPage",
      title: "Manage About Page",
      isPermitted: granted.includes("Manage_Custom_Pages"),
    },
    {
      icon: <FaFileContract />,
      label: "Manage Terms Page",
      path: "/TermsPage",
      title: "Manage Terms Page",
      isPermitted: granted.includes("Manage_Custom_Pages"),
    },
    {
      icon: <FaUserShield />,
      label: "Manage Privacy Page",
      path: "/PrivacyPolicyPage",
      title: "Manage Privacy Page",
      isPermitted: granted.includes("Manage_Custom_Pages"),
    },
    {
      icon: <FaUserShield />,
      label: "Custom Pages",
      path: "/customPages",
      title: "Custom Pages",
      isPermitted: granted.includes("Manage_Custom_Pages"),
    },
    {
      icon: <FaSearch />,
      label: "SEO Management",
      path: "/seo-management",
      title: "SEO Management",
      isPermitted: granted.includes("Manage_Pages_Metadata"),
    },
  ];

  const AuthSetting = [
    {
      icon: <MdOutlinePermScanWifi />,
      label: "Permissions",
      path: "/permissions",
      title: "Manage Permissions",
      isPermitted: granted.includes("Permissions"),
    },
    {
      icon: <GoLaw />,
      label: "Roles",
      path: "/role",
      title: "Manage Roles",
      isPermitted: granted.includes("Roles"),
    },
    {
      icon: <FaCriticalRole />,
      label: "Role Base Permission",
      path: "/rolePermissions",
      title: "Manage Role Base Permission",
      isPermitted: granted.includes("Role_Permissions"),
    },
    {
      icon: <FaCriticalRole />,
      label: "User Base Permissions",
      path: "/userPermissions",
      title: "Manage User Base Permissions",
      isPermitted: granted.includes("User_Permissions"),
    },
  ];

  const reportSections = [
    {
      icon: <FaRegLightbulb />,
      label: "Insights",
      path: "/reports",
      title: "Insights",
      isPermitted: insightGranted,
      // isPermitted: true, // <-- Add this
    },
    {
      icon: <MdReportGmailerrorred />,
      label: "Reports",
      path: "/all-reports",
      title: "Reports",
      isPermitted: granted.includes("Reports"),
      // isPermitted: true, // <-- Add this
    },
  ];

  const [isExpanded, setIsExpanded] = useState(() => {
    const savedState = localStorage.getItem("isSidebarExpanded");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  const [isSystemSettingsOpen, setIsSystemSettingsOpen] = useState(
    systemSettings.some((item) => location.pathname.includes(item.path)),
  );
  const [isReportspen, setIsReportspen] = useState(
    reportSections.some((item) => location.pathname.includes(item.path)),
  );
  const [isPagesManagementOpen, setIsPagesManagementOpen] = useState(
    pagesManagement.some((item) => location.pathname.includes(item.path)),
  );
  const toggleSystemSettings = () => setIsSystemSettingsOpen((prev) => !prev);
  const toggleReportspen = () => setIsReportspen((prev) => !prev);
  const togglePagesManagement = () => setIsPagesManagementOpen((prev) => !prev);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    localStorage.setItem("isSidebarExpanded", JSON.stringify(isExpanded));
  }, [isExpanded]);

  //
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsExpanded((prev) => {
      const newState = !prev;
      if (!isMobile) {
        localStorage.setItem("isSidebarExpanded", JSON.stringify(newState));
      }
      onToggle && onToggle(newState);
      return newState;
    });
  };
  //

  const [isAuthManagementOpen, setIsAuthManagementOpen] = useState(
    AuthSetting.some((item) => location.pathname.includes(item.path)),
  );

  const toggleAuthManagement = () => setIsAuthManagementOpen((prev) => !prev);

  return (
    <div>
      <section
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 100,
          width: isExpanded ? "250px" : "78px",
          height: "100%",
          background: "#000",
          color: "#fff",
          padding: "8px 16px",
          transition: "all 0.2s ease",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Link to={"/dashboard"}>
          <img
            src={Logo}
            alt="Company Logo"
            style={{ width: "97px" }}
            className="logo"
          />
        </Link>
        <div
          style={{
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          {isExpanded && (
            <p
              style={{
                fontSize: "23px",
                fontWeight: "600",
                opacity: isExpanded ? 1 : 0,
                transition: "all 0.2s ease",
                marginTop: "25px",
                textAlign: "center",
                width: "100%",
              }}
            >
              {user?.first_name || user?.last_name
                ? `Hello ${user?.first_name}👋`
                : "Hello Admin👋"}
            </p>
          )}
          <HiOutlineMenuAlt3
            onClick={toggleSidebar}
            style={{
              fontSize: "28px",
              color: "#fff",
              cursor: "pointer",
              position: "absolute",
              top: isExpanded ? "-92%" : "36%",
              right: isExpanded ? "1px" : "10px",
              transform: "translateY(-50%)",
            }}
          />
        </div>
        {isExpanded ? (
          <input
            type="text"
            placeholder="Search..."
            style={{
              fontSize: "14px",
              height: "40px",
              width: isExpanded ? "100%" : "50%",
              border: "none",
              borderRadius: "12px",
              padding: isExpanded ? "0 20px" : "0",
              background: "#333",
              color: "#fff",
              marginBottom: "20px",
            }}
          />
        ) : (
          <div
            style={{
              position: "relative",
              fontSize: "24px",
              cursor: "pointer",
              marginLeft: "9px",
            }}
          >
            <FaSearch
              style={{ cursor: "pointer" }}
              onClick={() => setIsExpanded(true)}
            />
          </div>
        )}
        <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
          {menuItems.map(
            ({ icon, label, onClick, path, isPermitted }, index) =>
              isPermitted && (
                <Link
                  to={path}
                  key={index}
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onClick) onClick();
                  }}
                >
                  <li
                    style={{
                      margin: "16px 0",
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      borderRadius: "8px",
                      transition: "background 0.3s ease",
                      cursor: "pointer",
                      color: "white",
                      background:
                        location.pathname === path ? "#333" : "transparent",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "24px",
                        color: "#fff",
                        marginRight: isExpanded ? "12px" : "0",
                        transition: "margin 0.3s ease",
                      }}
                    >
                      {icon}
                    </div>
                    <span
                      style={{
                        fontSize: "14px",
                        // fontWeight: "500",
                        opacity: isExpanded ? 1 : 0,
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      {label}
                    </span>
                  </li>
                </Link>
              ),
          )}
        </ul>
        <Dropdown
          isOpen={isAuthManagementOpen}
          toggle={toggleAuthManagement}
          label="Authorizations"
          items={AuthSetting}
          isExpanded={isExpanded}
          currentPath={location.pathname}
          icon={<FaUserShield />}
        />

        <Dropdown
          isOpen={isSystemSettingsOpen}
          toggle={toggleSystemSettings}
          label="System Settings"
          items={systemSettings}
          isExpanded={isExpanded}
          currentPath={location.pathname}
          icon={<MdOutlinePermScanWifi />}
        />

        <Dropdown
          isOpen={isReportspen}
          toggle={toggleReportspen}
          label="Reports"
          items={reportSections}
          isExpanded={isExpanded}
          currentPath={location.pathname}
          icon={<MdReport />}
        />

        <Dropdown
          isOpen={isPagesManagementOpen}
          toggle={togglePagesManagement}
          label="CMS"
          items={pagesManagement}
          isExpanded={isExpanded}
          currentPath={location.pathname}
          icon={<FaFileContract />}
        />
      </section>
      <style>
        {`
          section::-webkit-scrollbar {
            width: 8px;
          }
          section::-webkit-scrollbar-thumb {
            background-color: #555;
            border-radius: 8px;
            border: 2px solid #333;
          }
          section::-webkit-scrollbar-track {
            background: transparent;
          }
          section::-webkit-scrollbar-corner {
            background: transparent;
          }
      `}
      </style>
    </div>
  );
};
const Dropdown = ({
  isOpen,
  toggle,
  label,
  items,
  isExpanded,
  currentPath,
  icon,
}) =>
  items.some((s) => s.isPermitted) && (
    <>
      <li
        style={{
          margin: "16px 0",
          display: "flex",
          alignItems: "center",
          padding: "10px",
          borderRadius: "8px",
          transition: "background 0.3s ease",
          cursor: "pointer",
          color: "white",
          position: "relative",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#333")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        onClick={toggle}
      >
        <div
          style={{
            fontSize: "24px",
            color: "#fff",
            marginRight: isExpanded ? "12px" : "0",
            transition: "margin 0.3s ease",
          }}
        >
          {icon}
        </div>
        <span
          style={{
            fontSize: "14px",
            opacity: isExpanded ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#333")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {label}
        </span>
        <div
          style={{
            marginLeft: "auto",
            fontSize: "18px",
            transition: "transform 0.5s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#333")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {isOpen ? <HiOutlineChevronUp /> : <HiOutlineChevronDown />}
        </div>
      </li>
      <ul
        style={{
          paddingLeft: isExpanded ? "20px" : "8px",
          marginLeft: isExpanded ? "0" : "0px",
          position: "relative",
          backgroundColor: "#000",
          borderRadius: "8px",
          padding: "0 8px",
          maxHeight: isOpen ? "max-content" : "0",
          overflow: "hidden",
          opacity: isOpen ? 1 : 0,
          transition: "all 0.3s ease",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)",
        }}
      >
        {items.map(
          ({ icon, label, path, isPermitted, title }, index) =>
            isPermitted && (
              <Link
                to={path}
                key={index}
                style={{ textDecoration: "none" }}
                title={title}
              >
                <li
                  style={{
                    margin: "8px 0",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    borderRadius: "8px",
                    transition: "background 0.3s ease",
                    cursor: "pointer",
                    color: "white",
                    background: currentPath === path ? "#444" : "transparent",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      fontSize: "20px",
                      marginRight: isExpanded ? "12px" : "0",
                    }}
                  >
                    {icon}
                  </div>
                  {isExpanded && (
                    <span style={{ fontSize: "14px" }}>{label}</span>
                  )}
                </li>
              </Link>
            ),
        )}
      </ul>
    </>
  );

export default Sidebar;
